import { getSpcClientIdCookie } from '@shopee-user/authentication-utils';

import type { RedirectWithToCNonceProps } from '@shopee-user/business-customization-types';
import { isWebBridgeSupported } from '@shopee-user/platform';

export const redirectWithToCNonce = ({
  toCNonce,
  safelyRedirectToNextUrlFromQueryString,
}: RedirectWithToCNonceProps) => {
  safelyRedirectToNextUrlFromQueryString({
    toc_nonce: toCNonce,
    spc_clientid: getSpcClientIdCookie(),
  });
};

export const redirectAfterOneCredentialDelink = ({
  webViewLogoutSuccessfully,
  safelyRedirectToNextUrlFromQueryString,
  query,
}: {
  webViewLogoutSuccessfully: () => void;
  safelyRedirectToNextUrlFromQueryString: (
    query: Record<string, string>
  ) => void;
  query: Record<string, string>;
}) => {
  if (isWebBridgeSupported()) {
    webViewLogoutSuccessfully();
  } else {
    safelyRedirectToNextUrlFromQueryString({
      ...query,
    });
  }
};
